<template>
  <Combobox
    :showSearch="true"
    :groups="filterdOptions"
    :showSelection="false"
    :triggerLabel="!activeFilters.length ? t('admin.search.filters.title') : ''"
    :handle="handle"
    type="icon"
    @update:open="emit('update:open', $event)"
  />
</template>

<script setup>
// Libraries
import { computed, ref } from "vue";
import { map, includes, filter } from "lodash";

// Components
import { Combobox } from "@/SharedComponents/Filters/Combobox";

// Composables
import { useMain } from ".";
import { useI18n } from "vue-i18n";

// Emits
const emit = defineEmits(["update:open"]);

// Props
const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  activeFilters: {
    type: Array,
    required: true,
  },
  tenant: {
    type: Array,
    default: () => [],
  },
});

// Refs
const tenant = ref(props.tenant);
const handle = ref("main");

// Imported functions
const { t } = useI18n();
const { optionGroups } = useMain(tenant.value, props.type);

// Computed props
const filterdOptions = computed(() =>
  map(optionGroups, (group) => ({
    ...group,
    options: filter(
      group.options,
      (option) =>
        !includes(
          props.activeFilters.map((filter) => filter.id),
          option.id
        )
    ),
  }))
);
</script>
